  export const capitalizeFirstLetter = (p: string) => {
    return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
  }